<template>
  <footer class="footer mt-auto pt-3" v-if="visible">
    <span
      class="footer__to-top"
      onclick="$('html, body').animate({scrollTop: 0})"
    >
      <div class="container-xl">
        Nach oben <span><i class="icon icon-chevron-sort-up"></i></span>
      </div>
    </span>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    if (window.innerHeight < document.body.scrollHeight) this.visible = true;
  },
};
</script>

<style>
</style>
